import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectCustomerInStore, selectCustomerPageLoading, selectCustomerShowInitWaitingMessage } from '../_selectors/customer.selectors';

export class CustomerDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectCustomerPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectCustomerShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectCustomerInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
